import React from 'react';
import { FaCircleUser, FaBox } from "react-icons/fa6";
import { MdDeleteForever, MdEdit, MdDeleteSweep } from "react-icons/md";
import { Trash2, UserMinus  } from 'lucide-react';
import { HiAcademicCap } from "react-icons/hi2";
import { IoBook } from "react-icons/io5";
import { LiaSchoolSolid } from "react-icons/lia";
import { GoCheckCircleFill } from "react-icons/go";
import { GoXCircleFill } from "react-icons/go";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { TbFileShredder } from "react-icons/tb";
import { GrUserWorker } from "react-icons/gr";
import { LuBookText } from "react-icons/lu";
import { MdOutlineSettingsRemote } from "react-icons/md";
import { IoMdEye } from "react-icons/io";


import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledIcon = styled.div`
  font-size: ${props => props.inicio ? '80px' : props.tabla ? '20px' : props.papeleraT ? '25px' : '30px'};
  color: ${props => props.inicio ? 'white' : 'grey'};
  margin-left: ${props => props.alerta ? '90%' : props.papeleraT ? '20px' : ''};
  background-color:  ${props => props.inicio ? 'black':''};
  padding:${props => props.inicio ? '20px':''};
  border-radius:  ${props => props.inicio ? '60px':''};
  /*margin-top: ${props => props.grande ? '5%' : ''};  */

  &:hover {
    color: ${props => props.alerta ? 'red' : props.papeleraT ? 'rgba(0, 60, 102, 0.8)': 'white'};
  }
`;

const IconosGenerales = (props) => {

  const IconComponent = () => {
    if (props.id === 'eliminarSelect' && props.name === 'personaDelete') {
      return <UserMinus />;
    }
  
    switch (props.id) {
      case 'curso':
        return <HiAcademicCap style={{ width: '75%', margin: '0 auto' }} />;
      case 'categoria':
        return <IoBook style={{ width: '75%', margin: '0 auto' }} />;
      case 'subcategoria':
        return <LiaSchoolSolid />;
      case 'user':
        return <FaCircleUser />;
      case 'edit':
        return <MdEdit />;
      case 'delete':
        return <MdDeleteForever />;
      case 'deleteSelect':
        return <MdDeleteSweep />;
      case 'activarTodo':
        return <GoCheckCircleFill />;
      case 'desactivarTodo':
        return <GoXCircleFill />;
      case 'activarSelect':
        return <IoIosCheckmarkCircleOutline />;
      case 'desactivarSelect':
        return <IoIosCloseCircleOutline />;
      case 'eliminarTodo':
        return <TbFileShredder />;
      case 'eliminarSelect':
        return <Trash2 />; 
      case 'personas':
        return <GrUserWorker style={{ width: '75%', margin: '0 auto' }} />;
      case 'documentacion':
        return <LuBookText />;
      case 'inventario':
        return <FaBox style={{ width: '75%', margin: '0 auto' }} />;
      case 'git':
        return <MdOutlineSettingsRemote />;
      case 'eye':
        return <IoMdEye />
      default:
        return null;
    }
  };
  

  const Component = props.to ? Link : 'div';

  return (
    <StyledIcon as={Component} to={props.to} {...props}>
      <IconComponent />
    </StyledIcon>
  );
};

export default IconosGenerales;
